import React from 'react';
import { Brain, Mic, BarChart3, Cpu, HardDrive, Activity } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const usageData = [
  { name: 'Mon', cpu: 45, gpu: 32, memory: 60 },
  { name: 'Tue', cpu: 52, gpu: 45, memory: 65 },
  { name: 'Wed', cpu: 38, gpu: 28, memory: 55 },
  { name: 'Thu', cpu: 65, gpu: 72, memory: 78 },
  { name: 'Fri', cpu: 58, gpu: 55, memory: 70 },
  { name: 'Sat', cpu: 30, gpu: 22, memory: 45 },
  { name: 'Sun', cpu: 25, gpu: 18, memory: 40 },
];

function DashboardSection() {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Dashboard</h2>
        <p className="text-slate-400 mt-1">Koolaber Sovereign Infrastructure Overview</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-purple-600/20 flex items-center justify-center">
              <Cpu className="w-5 h-5 text-purple-400" />
            </div>
            <h3 className="text-sm font-medium text-slate-400">Compute</h3>
          </div>
          <p className="text-3xl font-bold text-white">48 vCPU</p>
          <p className="text-xs text-slate-500 mt-1">8 allocated · 40 available</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-emerald-600/20 flex items-center justify-center">
              <Activity className="w-5 h-5 text-emerald-400" />
            </div>
            <h3 className="text-sm font-medium text-slate-400">GPU</h3>
          </div>
          <p className="text-3xl font-bold text-white">4 GPUs</p>
          <p className="text-xs text-slate-500 mt-1">2 active · 2 idle</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-amber-600/20 flex items-center justify-center">
              <Brain className="w-5 h-5 text-amber-400" />
            </div>
            <h3 className="text-sm font-medium text-slate-400">Models</h3>
          </div>
          <p className="text-3xl font-bold text-white">5</p>
          <p className="text-xs text-slate-500 mt-1">3 local · 2 external</p>
        </div>

        <div className="glass-panel p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-blue-600/20 flex items-center justify-center">
              <HardDrive className="w-5 h-5 text-blue-400" />
            </div>
            <h3 className="text-sm font-medium text-slate-400">Storage</h3>
          </div>
          <p className="text-3xl font-bold text-white">240 GB</p>
          <p className="text-xs text-slate-500 mt-1">65 GB used · 175 GB free</p>
        </div>
      </div>

      {/* Usage Chart */}
      <div className="glass-panel p-6">
        <h3 className="text-lg font-semibold text-white mb-6 flex items-center gap-2">
          <BarChart3 className="w-5 h-5 text-purple-400" />
          Resource Usage (Last 7 Days)
        </h3>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={usageData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
              <XAxis dataKey="name" stroke="#64748B" tick={{ fill: '#94A3B8' }} />
              <YAxis stroke="#64748B" tick={{ fill: '#94A3B8' }} unit="%" />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#1E293B',
                  border: '1px solid #334155',
                  borderRadius: '8px',
                  color: '#F8FAFC',
                }}
              />
              <Line type="monotone" dataKey="cpu" stroke="#8B5CF6" strokeWidth={2} dot={{ fill: '#8B5CF6', r: 4 }} />
              <Line type="monotone" dataKey="gpu" stroke="#F59E0B" strokeWidth={2} dot={{ fill: '#F59E0B', r: 4 }} />
              <Line type="monotone" dataKey="memory" stroke="#10B981" strokeWidth={2} dot={{ fill: '#10B981', r: 4 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default DashboardSection;
